import { send } from "./auth";

/* ══ 관리 › MCP 토큰 — `/admin/mcp-tokens` · `crates/api/src/agent_tokens.rs` · docs/decisions/agent-token.md ══
   러너 토큰 표의 `kind='mcp'` 줄이다. 만료가 지나면 관문이 없는 토큰과 같은 401 로 끊고, 범위가 있으면
   그 프로젝트의 이슈만 본다(`scope.rs`). 모르는 값은 `null` 이다 — 빈 값으로 채우지 않는다. */

export type McpToken = {
  name: string;
  createdBy: string;
  createdAt: string;
  /** 한 번도 안 썼으면 null(「안 써 봄」). 5분 간격으로 찍힌다. */
  lastUsedAt: string | null;
  /** null 은 무제한. */
  expiresAt: string | null;
  expired: boolean;
  /** null 은 전체, 배열이면 그 프로젝트의 이슈만. 빈 배열은 아무것도 못 본다. */
  projects: string[] | null;
};

/** 고를 수 있는 만료 — 서버의 `EXPIRES_DAYS` 와 같다. null 은 무제한. */
export const EXPIRES_CHOICES: (number | null)[] = [null, 7, 30, 90];

const enc = encodeURIComponent;

export const mcpTokenApi = {
  list: () => send<{ tokens: McpToken[] }>("GET", "/admin/mcp-tokens").then((r) => r.tokens),
  /** 원문 토큰은 이 답에만 있다 — 다시 읽는 문이 없다. */
  create: (b: { name: string; expiresDays: number | null; projects: string[] | null }) =>
    send<McpToken & { token: string }>("POST", "/admin/mcp-tokens", b),
  /** 칸이 없으면 그대로, null 이면 지운다(만료 = 무제한 · 범위 = 전체). */
  update: (name: string, b: { name?: string; expiresAt?: string | null; projects?: string[] | null }) =>
    send<McpToken>("PATCH", `/admin/mcp-tokens/${enc(name)}`, b),
  revoke: (name: string) => send<null>("DELETE", `/admin/mcp-tokens/${enc(name)}`),
};
export type McpTokenApi = typeof mcpTokenApi;

/** 오늘부터 N일 뒤의 RFC3339 — 고치기 폼의 「만료 다시 정하기」. */
export function daysFromNow(days: number, now = Date.now()): string {
  return new Date(now + days * 86_400_000).toISOString();
}
